import moment from 'moment-jalaali';

moment.loadPersian({ dialect: 'persian-modern' });

// YY PersianMonth D
export function dateFormat(value) {
    return moment(value).format('jD jMMMM jYY');
}

// YYYY PersianMonth DD
export function fullDateFormat(value) {
    return moment(value).format('jDD jMMMM jYYYY');
}
// YYYY PersianMonth D - ساعت H:mm
export function dateFormatWithTime(value) {
    return moment(value).format('jD jMMMM jYY - ساعت H:mm');
}

// YYYY PersianMonth DD - ساعت HH:mm
export function fullDateFormatWithTime(value) {
    return moment(value).format('jDD jMMMM jYYYY - ساعت HH:mm');
}

// ساعت H:mm
export function timeEnter(value) {
    return moment(value).format('ساعت H:mm');
}
// ساعت HH:mm
export function fullTimeEnter(value) {
    return moment(value).format('ساعت HH:mm');
}

// display a moment in relation to a time other than now in a human readable length of time.
export function dateFormatToNow(value) {
    return moment().to(value, true);
}
